import React, { useState } from "react";
import "./Weather.css";
import Weatherinfo from "./Weatherinfo";
import Weatherforecast from "./Weatherforecast";

import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    console.log(response.data);
    setWeatherData({
      ready: true,
      coordinates: response.data.coord,
      temperature: response.data.main.temp,
      humidity: response.data.main.humidity,
      date: new Date(response.data.dt * 1000),
      description: response.data.weather[0].description,
      icon: response.data.weather[0].icon,
      wind: response.data.wind.speed,
      city: response.data.name,
    });
  }
  function search() {
    let apiKey = `45c635f6554467de219d60506c6e3432`;

    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search(city);

    // search for a city
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                className="form-control form-control-override"
                type="Search"
                placeholder="Enter a city.."
                aria-label="Search"
                autoComplete="off"
                autoFocus="on"
                onChange={handleCityChange}
              />
            </div>

            <div className="col-3">
              <button
                className="btn btn-primary w-100 button-override"
                type="submit"
              >
                Search
              </button>
            </div>
          </div>
        </form>
        <Weatherinfo data={weatherData} />
        <Weatherforecast coordinates={weatherData.coordinates} />
      </div>
    );
  } else {
    search();
    return "loading";
  }
}
